// Singleton shared parser worker — one worker handles PascalCase→camelCase key
// conversion for all ~22 useWebSocket consumers. Parsing is I/O-light (~0.5 ms per
// job), so a single worker provides sufficient throughput without adding thread
// pressure. Contrast with the group worker pool (Phase 4) which is CPU-heavier and
// benefits from real parallelism.

class ParserWorkerPool {
  private readonly _worker: Worker;
  private readonly _consumers = new Map<
    string,
    (eventName: string, parsed: object[]) => void
  >();

  constructor() {
    this._worker = new Worker(
      new URL("../workers/messageParser.worker.ts", import.meta.url),
      { type: "module" },
    );
    this._worker.onmessage = (e: MessageEvent) => {
      if (e.data.error) return;
      const cb = this._consumers.get(e.data.consumerId);
      if (cb) cb(e.data.eventName, e.data.parsed);
    };
    this._worker.onerror = (e: ErrorEvent) => {
      console.error("messageParser worker error:", e.message);
    };
  }

  register(
    id: string,
    cb: (eventName: string, parsed: object[]) => void,
  ): void {
    this._consumers.set(id, cb);
  }

  unregister(id: string): void {
    this._consumers.delete(id);
  }

  submit(id: string, eventName: string, rawMessage: string | object[]): void {
    this._worker.postMessage({ consumerId: id, eventName, rawMessage });
  }
}

export const parserWorkerPool = new ParserWorkerPool();
